import React, { useEffect, useState } from 'react';
import { api } from '../App';
import { workspaceError } from '../contexts/WorkspaceContext';
import { Button } from './ui/button';

const issues = { orphan_group_links: 'Hay movimientos o membresías sin un grupo existente.', unfinished_close: 'Hay un cierre sin terminar.',
  duplicate_members: 'Un perfil aparece varias veces como miembro.', mixed_currencies: 'Los gastos mezclan monedas.',
  invalid_expenses: 'Hay importes inválidos.', partial_close: 'Un grupo abierto ya tiene cargos de cierre.',
  missing_or_duplicate_charges: 'Faltan cargos de miembros o hay cargos duplicados.', charge_mismatch: 'Los cargos no coinciden con el reparto.',
  missing_members: 'Hay gastos sin miembros.', owner_not_member: 'El propietario no figura como miembro.' };
issues.cross_profile_workspace = 'Este grupo de un tablero adicional mezcla finanzas de varios perfiles. Revisa su traslado a los tableros personales.';

export default function WorkspaceLegacyGroups({ board }) {
  const [request, setRequest] = useState(0);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [downloading, setDownloading] = useState(false);
  const download = async id => {
    setDownloading(true); setError('');
    try {
      const response = await api.get(`/admin/workspace-operations/legacy-group-reconciliation/${encodeURIComponent(id)}`, { responseType: 'blob' });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url; link.download = 'conciliacion-grupo.json'; document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { setError('No se pudo descargar el plan de conciliación. Actualiza la revisión e intenta de nuevo.'); }
    finally { setDownloading(false); }
  };
  useEffect(() => {
    if (!request) return;
    let current = true;
    setBusy(true); setError(''); setData(null);
    api.get(`/admin/workspace-operations/${board}/legacy-groups`).then(({ data }) => { if (current) setData(data); })
      .catch(e => { if (current) setError(workspaceError(e)); }).finally(() => { if (current) setBusy(false); });
    return () => { current = false; };
  }, [board, request]);
  return <section aria-label="Revisión de grupos de reparto" className="space-y-3 rounded border p-3">
    <h4 className="font-semibold">Grupos de reparto anteriores</h4>
    <p className="text-sm text-slate-600">Consulta si sus cierres y cargos coinciden antes de restaurar. Esta revisión no modifica saldos.</p>
    <Button variant="outline" disabled={busy} onClick={() => setRequest(value => value + 1)}>Revisar grupos de reparto</Button>
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    {data && <div role="status" className="space-y-2 text-sm">
      <p>{!data.has_links ? 'No hay grupos de reparto vinculados.' : data.consistent ? 'Los cierres y cargos actuales coinciden. La restauración exige que tampoco hayan cambiado desde la copia y se realiza con los procesos detenidos.' : 'Hay diferencias que deben reconciliarse antes de restaurar.'}</p>
      {(data.issues || []).map(code => <p className="text-amber-800" key={code}>{issues[code] || code}</p>)}
      {(data.groups || []).map(group => <div key={group.id} className="rounded border p-2"><strong>{group.name}</strong><p>{group.members} miembros · {group.expenses} gastos · {group.charges} cargos</p><Button variant="outline" size="sm" disabled={downloading} onClick={() => download(group.id)}>Descargar plan de conciliación</Button></div>)}
      {(data.orphan_group_ids || []).map(id => <div key={id} className="rounded border p-2"><p>Grupo no encontrado: {id}</p><Button variant="outline" size="sm" disabled={downloading} onClick={() => download(id)}>Descargar plan de conciliación</Button></div>)}
      {data.has_links && <p className="text-muted-foreground">El plan contiene los registros originales y una propuesta editable. Su aplicación es administrativa, con los procesos detenidos; descargarlo no modifica saldos.</p>}
    </div>}
  </section>;
}
